import {
  Thumbnail,
  Thumbnail1,
  Thumbnail10,
  Thumbnail11,
  Thumbnail12,
  Thumbnail13,
  Thumbnail14,
  Thumbnail15,
  Thumbnail2,
  Thumbnail4,
  Thumbnail5,
  Thumbnail6,
  Thumbnail7,
  Thumbnail8,
  Thumbnail9,
} from "@/comman/Images";
import parsePhoneNumberFromString from "libphonenumber-js";
import { AiOutlineNotification } from "react-icons/ai";
import { FaProjectDiagram } from "react-icons/fa";
import { GiPlatform } from "react-icons/gi";
import { LiaIndustrySolid } from "react-icons/lia";
import { MdOutlineDesignServices, MdOutlineWorkOutline } from "react-icons/md";
import { TbTopologyComplex } from "react-icons/tb";

export const projects = [
  {
    name: "Kloo",
    slug: "kloo",
    title:
      "Kloo is an AI-powered Accounts Payable automation platform that aims to streamline financial processes for businesses. It focuses on enhancing efficiency, reducing costs, and increasing control over spend within the procure-to-pay cycle. Kloo offers solutions like automated invoice management, a Purchasing Copilot for natural language requests, and real-time spend analytics.",
    details: [
      "Kloo is an innovation layer on your accounting platform making finance teams more efficient, reducing costs and increasing control",
      "We offer our clients an integrated approach. A full digital strategy – not just a website. The whole spectrum of digital agency services underpinned by an enthusiastic understanding of your business, your audience, and your objectives.",
    ],
    images: [
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/KLOO/project-ss-1.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/KLOO/project-ss-2.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/KLOO/project-ss-3.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/KLOO/project-ss-4.png",
    ],
    icons: [
      {
        image: "https://work.neoverce.com/assets/React-icon-f2cadfd0.svg",
        links: "https://react.dev/",
        IconLabel: "React",
      },
      {
        image:
          "https://work.neoverce.com/assets/Tailwind_CSS_Logo-29b2f046.svg",
        links: "https://tailwindcss.com/",
        IconLabel: "Tailwind CSS",
      },
      {
        image:
          "https://work.neoverce.com/assets/Postgresql_elephant-fe85bc84.svg",
        links: "https://www.postgresql.org/",
        IconLabel: "Postgresql",
      },
      {
        image: "https://work.neoverce.com/assets/laravel-9798d294.webp",
        links: "https://laravel.com/",
        IconLabel: "Laravel",
      },
    ],
  },
  {
    name: "Tripigos",
    slug: "tripigos",
    title:
      "Tripigos – Your Destination Management Company for Seamless Holiday Experiences.",
    details: [
      // 'Take a fresh approach with Neoverce an award-winning digital marketing agency in Manchester and Preston with a high-performance track record for some of the UK s leading brands.',
      // 'We offer our clients an integrated approach. A full digital strategy – not just a website. The whole spectrum of digital agency services underpinned by an enthusiastic understanding of your business, your audience, and your objectives.',
    ],
    images: [
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/TRIPIGOS/project-ss-1.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/TRIPIGOS/project-ss-2.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/TRIPIGOS/project-ss-3.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/TRIPIGOS/project-ss-4.png",
    ],
    icons: [
      {
        image:
          "https://work.neoverce.com/assets/next-js-seeklogo.com-cab09f82.svg",
        links: "https://nextjs.org/",
        IconLabel: "Next JS",
      },
      {
        image:
          "https://work.neoverce.com/assets/Tailwind_CSS_Logo-29b2f046.svg",
        links: "https://tailwindcss.com/",
        IconLabel: "Tailwind CSS",
      },
      {
        image: "https://work.neoverce.com/assets/Node.js_logo-dc8800bf.svg",
        links: "https://nodejs.org/",
        IconLabel: "Node JS",
      },
      {
        image:
          "https://work.neoverce.com/assets/Amazon_Web_Services_Logo-89d59062.svg",
        links: "https://aws.amazon.com/",
        IconLabel: "AWS",
      },
      {
        image:
          "https://work.neoverce.com/assets/Postgresql_elephant-fe85bc84.svg",
        links: "https://www.postgresql.org/",
        IconLabel: "Postgresql",
      },
      {
        image:
          "https://work.neoverce.com/assets/adonis-js-seeklogo.com-83081c6f.svg",
        links: "https://adonisjs.com/",
        IconLabel: "Adonis JS",
      },
    ],
  },

  {
    name: "NJCapital",
    slug: "NJCapital",
    title:
      "NJ Capital – Seamless Digital Loans Backed by NJ Group’s Financial Expertise",
    details: [
      "Digital lending based on data sciences, has caused a fundamental transformation in the experience of the retail borrower. NJ Capital Private Limited (NJC) marks the entry of NJ group into digital lending. NJC. a registered Non Banking Finance Company (NBFC), operates the retail lending arm of the NJ Group. The company endeavours to fulfill the credit requirements of its clients by providing them innovative loan products at an affordable cost, thereby enabling the group to be a one stop shop providing for all their financial needs.",
      "Relying on technology, NJC strives to turn lending into a quick, simple and hassle free process. The fully automated process leads to elimination of paperwork, physical movements (of either papers or clients), quick loan disbursals and smooth loan servicing .We endeavour to provide to the client a world class borrowing experience that is truly seamless, intuitive, convenient and user friendly. The use of data analytics helps in profiling client risk and delivering the right loan product at an appropriate cost, thereby bringing substantial economic gains to them.",
    ],
    images: [
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/IFA/project-ss-1.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/IFA/project-ss-2.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/IFA/project-ss-3.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/IFA/project-ss-4.png",
    ],
    icons: [
      {
        image: "https://work.neoverce.com/assets/React-icon-f2cadfd0.svg",
        links: "https://react.dev/",
        IconLabel: "React",
      },
      {
        image: "https://work.neoverce.com/assets/java-icon-3db65323.svg",
        links: "https://www.java.com/en/",
        IconLabel: "JAVA",
      },
      {
        image: "https://work.neoverce.com/assets/mysql-ar21-12ffac41.svg",
        links: "https://www.mysql.com/",
        IconLabel: "My SQL",
      },
      {
        image: "https://work.neoverce.com/assets/Bootstrap_logo-07788d6d.svg",
        links: "https://react-bootstrap.netlify.app/",
        IconLabel: "Bootstrap",
      },
      {
        image:
          "https://work.neoverce.com/assets/Postgresql_elephant-fe85bc84.svg",
        links: "https://www.postgresql.org/",
        IconLabel: "Postfresql",
      },
      {
        image:
          "https://work.neoverce.com/assets/adonis-js-seeklogo.com-83081c6f.svg",
        links: "https://adonisjs.com/",
        IconLabel: "Adonis JS",
      },
    ],
    projectLink: "https://www.njcapital.in/",
  },

  {
    name: "Crom",
    slug: "crom",
    title:
      "Crom – A Scalable Cross-Platform Web & Mobile Solution Built for Modern Business.",
    details: [
      // 'Take a fresh approach with Neoverce an award-winning digital marketing agency in Manchester and Preston with a high-performance track record for some of the UK s leading brands.',
      // 'We offer our clients an integrated approach. A full digital strategy – not just a website. The whole spectrum of digital agency services underpinned by an enthusiastic understanding of your business, your audience, and your objectives.',
    ],
    images: [
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/CROM/project-ss-1.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/CROM/project-ss-2.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/CROM/project-ss-3.png",
    ],
    icons: [
      {
        image: "https://work.neoverce.com/assets/React-icon-f2cadfd0.svg",
        links: "https://react.dev/",
        IconLabel: "React",
      },
      {
        image: "https://work.neoverce.com/assets/react-native-1-12c0b206.svg",
        links: "https://reactnative.dev/",
        IconLabel: "React Native",
      },
      {
        image:
          "https://work.neoverce.com/assets/next-js-seeklogo.com-cab09f82.svg",
        links: "https://nextjs.org/",
        IconLabel: "Next JS",
      },
      {
        image: "https://work.neoverce.com/assets/Node.js_logo-dc8800bf.svg",
        links: "https://nodejs.org/en",
        IconLabel: "Node JS",
      },
      {
        image: "https://work.neoverce.com/assets/MongoDB_Logo-efabd5ef.svg",
        links: "https://www.mongodb.com/",
        IconLabel: "Mongo DB",
      },
      {
        image: "https://work.neoverce.com/assets/CoreUi-34df5e6e.png",
        links: "https://coreui.io/",
        IconLabel: "Core UI",
      },
    ],
  },

  {
    name: "Flex League",
    slug: "flex-league",
    title:
      "Flex League – On-Demand Tennis & Padel Leagues That Fit Your Schedule.",
    details: [
      "Flex league is the ultimate platform for Tennis and Padel player enthusiasts (and other sports in the future!). We offer competitive leagues and tournaments, as well as hitting partners of similar skill level to you, and everything is fit to Your Schedule. You get to schedule all matches whenever you want and report the score in the app!",
    ],
    images: [
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/FLEXLEAGUE/project-ss-1.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/FLEXLEAGUE/project-ss-2.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/FLEXLEAGUE/project-ss-3.png",
    ],
    icons: [
      {
        image: "https://work.neoverce.com/assets/react-native-1-12c0b206.svg",
        links: "https://reactnative.dev/",
        IconLabel: "React Native",
      },
      {
        image:
          "https://www.hyperpay.com/wp-content/uploads/2022/10/Hyperpay-logo-svg-1.png",
        links: "https://www.hyperpay.com/",
        IconLabel: "Hyper Pay",
      },
      {
        image: "https://work.neoverce.com/assets/laravel-9798d294.webp",
        links: "https://laravel.com/",
        IconLabel: "Laravel",
      },
    ],
  },

  {
    name: "Boomio",
    slug: "boomio",
    title: "Boomio – Smart Loyalty & Rewards Platform for Small Businesses.",
    details: [
      "Boomio is on a mission to make digital customer loyalty tools available to small and medium businesses. Right now, such tools are only available to the enterprise segment, as developing them in-house costs thousands. We have built an online platform and a mobile app that allows businesses to create and manage their own rewards & loyalty system for a small subscription fee.",
    ],
    images: [
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/BOOMIO/project-ss-1.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/BOOMIO/project-ss-2.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/BOOMIO/project-ss-3.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/BOOMIO/project-ss-4.png",
    ],
    icons: [
      {
        image: "https://work.neoverce.com/assets/React-icon-f2cadfd0.svg",
        links: "https://react.dev/",
        IconLabel: "React",
      },
      {
        image:
          "https://www.hyperpay.com/wp-content/uploads/2022/10/Hyperpay-logo-svg-1.png",
        links: "https://nodejs.org/",
        IconLabel: "Node JS",
      },
      {
        image:
          "https://work.neoverce.com/assets/Amazon_Web_Services_Logo-89d59062.svg",
        links: "https://aws.amazon.com/",
        IconLabel: "AWS",
      },
      {
        image: "https://work.neoverce.com/assets/MongoDB_Logo-efabd5ef.svg",
        links: "https://www.mongodb.com/",
        IconLabel: "Mongo DB",
      },
    ],
    projectLink: "https://www.boomio.com/",
  },

  {
    name: "Meeko",
    slug: "meeko",
    title:
      "Meeko – Virtual Learning Platform Connecting Educators, Students & Parents.",
    details: [
      "Meeko is an online learning platform that connects Educators, students, & parents to enhance the learning experience with virtual & free online live courses. meeko,online learning platforms,live class,online classes app,live online class,live online classes,virtual online classes,top online learning platforms,e learning platforms,online courses,free online courses,online kids classes",
    ],
    images: [
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MEEKO/project-ss-1.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MEEKO/project-ss-2.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MEEKO/project-ss-3.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MEEKO/project-ss-4.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MEEKO/project-ss-5.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MEEKO/project-ss-6.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MEEKO/project-ss-7.png",
    ],
    icons: [
      {
        image: "https://work.neoverce.com/assets/React-icon-f2cadfd0.svg",
        links: "https://react.dev/",
        IconLabel: "React",
      },
      {
        image: "https://work.neoverce.com/assets/Node.js_logo-dc8800bf.svg",
        links: "https://nodejs.org/en",
        IconLabel: "Node",
      },
      {
        image:
          "https://work.neoverce.com/assets/Amazon_Web_Services_Logo-89d59062.svg",
        links: "https://aws.amazon.com/",
        IconLabel: "AWS",
      },
      {
        image: "https://work.neoverce.com/assets/Logo_Jitsi-7f24f1e6.svg",
        links: "https://meet.jit.si/",
        IconLabel: "JIt",
      },
      {
        image: "https://work.neoverce.com/assets/Three.js_Icon-fe160e71.svg",
        links: "https://threejs.org/",
        IconLabel: "3 JS",
      },
    ],
    projectLink: "https://www.meeko.world/",
  },

  {
    name: "Sitka",
    slug: "sitka",
    title:
      "Sitka Gear – High-Performance Hunting Apparel Engineered for the Wild.",
    details: [
      // 'Take a fresh approach with Neoverce an award-winning digital marketing agency in Manchester and Preston with a high-performance track record for some of the UK s leading brands.',
      // 'We offer our clients an integrated approach. A full digital strategy – not just a website. The whole spectrum of digital agency services underpinned by an enthusiastic understanding of your business, your audience, and your objectives.',
    ],
    images: [
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/SITKA/project-ss-1.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/SITKA/project-ss-2.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/SITKA/project-ss-3.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/SITKA/project-ss-4.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/SITKA/project-ss-5.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/SITKA/project-ss-6.png",
    ],
    icons: [
      {
        image:
          "https://work.neoverce.com/assets/next-js-seeklogo.com-cab09f82.svg",
        links: "https://nextjs.org/",
        IconLabel: "Next Js",
      },
      {
        image:
          "https://work.neoverce.com/assets/Tailwind_CSS_Logo-29b2f046.svg",
        links: "https://tailwindcss.com/",
        IconLabel: "tailwind",
      },
      {
        image: "https://work.neoverce.com/assets/auth0-icon-c97a71e2.svg",
        links: "https://auth0.com/",
        IconLabel: "Auth 0",
      },
      {
        image:
          "https://work.neoverce.com/assets/Amazon_Web_Services_Logo-89d59062.svg",
        links: "https://aws.amazon.com/",
        IconLabel: "AWS",
      },
      {
        image:
          "https://work.neoverce.com/assets/Postgresql_elephant-fe85bc84.svg",
        links: "https://www.postgresql.org/",
        IconLabel: "Postgresql",
      },
      {
        image: "https://work.neoverce.com/assets/bigcommerce-icon-2220d313.svg",
        links: "https://adonisjs.com/",
        IconLabel: "Adonis JS",
      },
      {
        image:
          "https://work.neoverce.com/assets/contentful-logo-vector-9d64a403.svg",
        links: "https://www.contentful.com/",
        IconLabel: "Content Full",
      },
      {
        image: "https://work.neoverce.com/assets/Klaviyo-85974c35.svg",
        links: "https://www.klaviyo.com/",
        IconLabel: "Klaviyo",
      },
    ],
    projectLink: "https://www.sitkagear.com/",
  },

  {
    name: "BeLiving",
    slug: "beLiving",
    title:
      "BeLiving – Bridging Generations Through Shared Living & Meaningful Services.",
    details: [
      "We create valuable meetings that care for you or your loved ones. Regardless if you want to rent, rent out, need simple services, or need an extra income. By letting young adults who need a living, also when agreed lend a helping hand, we bridge generations and create multiple values for both young and elderly. By contracting young adults for simple repetitive services, we enable them to have an extra income during their studies or the beginning of adulthood while letting them doing good. We enable a helping hand through simple services that most of us can offer and everyone will value.",
    ],
    images: [
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/BELIVING/project-ss-1.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/BELIVING/project-ss-2.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/BELIVING/project-ss-3.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/BELIVING/project-ss-4.png",
    ],
    icons: [
      {
        image: "https://work.neoverce.com/assets/Node.js_logo-dc8800bf.svg",
        links: "https://nodejs.org/en",
        IconLabel: "Node JS",
      },
      {
        image: "https://work.neoverce.com/assets/MongoDB_Logo-efabd5ef.svg",
        links: "https://www.mongodb.com/",
        IconLabel: "Mongo DB",
      },
      {
        image:
          "https://work.neoverce.com/assets/angular-seeklogo.com-5ca504e3.svg",
        links: "https://angular.io/",
        IconLabel: "Angular",
      },
    ],
    projectLink: "https://www.beliving.org/",
  },

  {
    name: "Gorewear",
    slug: "gorewear",
    title:
      "GOREWEAR – Performance Apparel Engineered for Runners, Cyclists & Endurance Athletes.",
    details: [
      // 'Take a fresh approach with Neoverce an award-winning digital marketing agency in Manchester and Preston with a high-performance track record for some of the UK s leading brands.',
      // 'We offer our clients an integrated approach. A full digital strategy – not just a website. The whole spectrum of digital agency services underpinned by an enthusiastic understanding of your business, your audience, and your objectives.',
    ],
    images: [
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/GOREWEAR/project-ss-1.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/GOREWEAR/project-ss-2.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/GOREWEAR/project-ss-3.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/GOREWEAR/project-ss-4.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/GOREWEAR/project-ss-5.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/GOREWEAR/project-ss-6.png",
    ],
    icons: [
      {
        image:
          "https://work.neoverce.com/assets/next-js-seeklogo.com-cab09f82.svg",
        links: "https://nextjs.org/",
        IconLabel: "Next JS",
      },
      {
        image:
          "https://work.neoverce.com/assets/Tailwind_CSS_Logo-29b2f046.svg",
        links: "https://tailwindcss.com/",
        IconLabel: "Tailwinds CSS",
      },
      {
        image: "https://work.neoverce.com/assets/auth0-icon-c97a71e2.svg",
        links: "https://auth0.com/",
        IconLabel: "Auth 0",
      },
      {
        image:
          "https://work.neoverce.com/assets/Amazon_Web_Services_Logo-89d59062.svg",
        links: "https://aws.amazon.com/",
        IconLabel: "AWS",
      },
      {
        image:
          "https://work.neoverce.com/assets/Postgresql_elephant-fe85bc84.svg",
        links: "https://www.postgresql.org/",
        IconLabel: "Posrgresql",
      },
      {
        image: "https://work.neoverce.com/assets/bigcommerce-icon-2220d313.svg",
        links: "https://www.bigcommerce.com/",
        IconLabel: "Big Commerce",
      },
      {
        image:
          "https://work.neoverce.com/assets/contentful-logo-vector-9d64a403.svg",
        links: "https://www.contentful.com/",
        IconLabel: "Content full",
      },
      {
        image: "https://work.neoverce.com/assets/Klaviyo-85974c35.svg",
        links: "https://www.klaviyo.com/",
        IconLabel: "Klaviyo",
      },
    ],
    projectLink: "http://gorewear.com/",
  },

  {
    name: "MT-Hood",
    slug: "mtHood",
    title:
      "MT-Hood Meadows – Oregon’s Premier Ski & Adventure Destination Year-Round.",
    details: [
      "Mount Hood Meadows is one of the largest ski resorts in Oregon and the largest ski resort on Mount Hood. It is located about 67 miles east of Portland, and 35 miles from Hood River along Oregon Route 35. It has both Alpine and Nordic ski areas and offers night skiing, lessons and equipment rentals. In the summer Meadows offers scenic chair rides, a premier hiking experience on Mt. Hood and events on the weekends.",
    ],
    images: [
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MTHOOD/project-ss-1.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MTHOOD/project-ss-2.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MTHOOD/project-ss-3.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MTHOOD/project-ss-4.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MTHOOD/project-ss-5.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/MTHOOD/project-ss-6.png",
    ],
    icons: [
      {
        image:
          "https://work.neoverce.com/assets/next-js-seeklogo.com-cab09f82.svg",
        links: "https://nextjs.org/",
        IconLabel: "Next JS",
      },
      {
        image:
          "https://work.neoverce.com/assets/Tailwind_CSS_Logo-29b2f046.svg",
        links: "https://tailwindcss.com/",
        IconLabel: "Tailwind CSS",
      },
      {
        image:
          "https://work.neoverce.com/assets/Typescript_logo_2020-139ae451.svg",
        links: "https://www.typescriptlang.org/",
        IconLabel: "Type script",
      },
      {
        image:
          "https://work.neoverce.com/assets/Amazon_Web_Services_Logo-89d59062.svg",
        links: "https://aws.amazon.com/",
        IconLabel: "AWS",
      },
      {
        image: "https://work.neoverce.com/assets/Azure_Logo-8ea658a5.svg",
        links: "https://azure.microsoft.com/en-in",
        IconLabel: "Azure",
      },
      {
        image: "https://work.neoverce.com/assets/aws-dynamodb-683f1fd1.svg",
        links: "https://aws.amazon.com/pm/dynamodb/",
        IconLabel: "AWS",
      },
      {
        image: "https://work.neoverce.com/assets/Firebase_Logo-35235a19.svg",
        links: "https://firebase.google.com/",
        IconLabel: "Firebase",
      },
      {
        image:
          "https://work.neoverce.com/assets/stripe-seeklogo.com-d79b22b1.svg",
        links: "https://stripe.com/en-in",
        IconLabel: "Stripe",
      },
      {
        image: "https://work.neoverce.com/assets/stripe-2162272e.png",
        links: "https://strapi.io/",
        IconLabel: "Strapi",
      },
      {
        image: "https://work.neoverce.com/assets/bigcommerce-icon-2220d313.svg",
        links: "https://www.bigcommerce.com/",
        IconLabel: "Big Commerce",
      },
      {
        image: "https://work.neoverce.com/assets/Sass_Logo_Color-72aa6e83.svg",
        links: "https://sass-lang.com/",
        IconLabel: "SASS",
      },
    ],
    projectLink: "https://www.skihood.com/",
  },

  // {
  //   name: "Safespace",
  //   slug: "safespace",
  //   title:
  //     "Safespace – A Secure and Supportive Digital Platform for Personal Wellbeing.",
  //   details: [
  //     // 'Take a fresh approach with Neoverce an award-winning digital marketing agency in Manchester and Preston with a high-performance track record for some of the UK s leading brands.',
  //     // 'We offer our clients an integrated approach. A full digital strategy – not just a website. The whole spectrum of digital agency services underpinned by an enthusiastic understanding of your business, your audience, and your objectives.',
  //   ],
  //   images: [
  //     "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/SAFESPACE/project-ss-1.png",
  //     "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/SAFESPACE/project-ss-2.png",
  //     "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/SAFESPACE/project-ss-3.png",
  //   ],
  //   icons: [
  //     {
  //       image: "https://work.neoverce.com/assets/React-icon-f2cadfd0.svg",
  //       links: "https://react.dev/",
  //       IconLabel: "React",
  //     },
  //     {
  //       image: "https://work.neoverce.com/assets/react-native-1-12c0b206.svg",
  //       links: "https://reactnative.dev/",
  //       IconLabel: "React Native",
  //     },
  //     {
  //       image: "https://work.neoverce.com/assets/java-icon-3db65323.svg",
  //       links: "https://www.java.com/en/",
  //       IconLabel: "JAVA",
  //     },
  //     {
  //       image: "https://work.neoverce.com/assets/Firebase_Logo-35235a19.svg",
  //       links: "https://firebase.google.com/",
  //       IconLabel: "Fire Base",
  //     },
  //     {
  //       image: "https://work.neoverce.com/assets/stripe-2162272e.png",
  //       links: "https://strapi.io/",
  //       IconLabel: "Strapi",
  //     },
  //   ],
  //   projectLink: "https://makesafe.space/",
  // },

  // {
  //   name: 'Yoloh',
  //   slug: 'yoloh',
  //   title:
  //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  //   details: [
  //     'Yoloh is a digital platform that offers one-stop insurance services. Get insurance at your own convenience through our secure platform without having the need of multiple interactions.',
  //   ],
  //   images: [
  //     'https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/YOLOH/project-ss-1.png',
  //     'https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/YOLOH/project-ss-2.png',
  //     'https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/YOLOH/project-ss-4.png',
  //     'https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/YOLOH/project-ss-5.png',
  //     'https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/YOLOH/project-ss-6.png',
  //     'https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/YOLOH/project-ss-7.png',
  //   ],
  //   icons: [
  //     {
  //       image: 'https://work.neoverce.com/assets/React-icon-f2cadfd0.svg',
  //       links: 'https://react.dev/',
  //     },
  //     {
  //       image: 'https://work.neoverce.com/assets/mysql-ar21-12ffac41.svg',
  //       links: 'https://www.mysql.com/',
  //     },
  //     {
  //       image: 'https://work.neoverce.com/assets/Node.js_logo-dc8800bf.svg',
  //       links: 'https://nodejs.org/',
  //     },
  //     {
  //       image:
  //         'https://work.neoverce.com/assets/angular-seeklogo.com-5ca504e3.svg',
  //       links: 'https://angular.io/',
  //     },
  //   ],
  //   projectLink: 'http://customer-stage.theintellify.net/',
  // },

  // {
  //   name: 'Dine N Dash',
  //   slug: 'dineNdash',
  //   title:
  //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  //   details: [
  //     'An admin panel for Dine N Dash franchise restaurants all the over the india.',
  //   ],
  //   images: [
  //     'https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/DINENDASH/project-ss-1.png',
  //     'https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/DINENDASH/project-ss-2.png',
  //     'https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/DINENDASH/project-ss-3.png',
  //     'https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/DINENDASH/project-ss-4.png',
  //     'https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/DINENDASH/project-ss-5.png',
  //     'https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/DINENDASH/project-ss-6.png',
  //   ],
  //   icons: [
  //     {
  //       image: 'https://work.neoverce.com/assets/React-icon-f2cadfd0.svg',
  //       links: 'https://react.dev/',
  //     },
  //     {
  //       image: 'https://work.neoverce.com/assets/Node.js_logo-dc8800bf.svg',
  //       links: 'https://nodejs.org/',
  //     },
  //     {
  //       image: 'https://work.neoverce.com/assets/Bootstrap_logo-07788d6d.svg',
  //       links: 'https://react-bootstrap.netlify.app/',
  //     },
  //   ],
  // },
  {
    name: "KKP-Bhadli",
    slug: "KKPBhadli",
    title:
      "KKP Bhadli – Connecting the Kutch Kadva Patidar Community Through a Unified Digital Platform.",
    details: [
      "KKP Bhadli is the official community app of the Kutch Kadva Patidar Samaj, designed to bring our community closer together. Stay updated on the latest news, connect with fellow community members, and never miss out on important events and birthdays.",
      "KKP bhadli app is community app of kutch kadva patidar samaj. You can see updates of members in the community,connect with people of kkp samaj community. You can get Birthday Reminders , Events and News of kutch kadva patidar community. The app built for connecting business and reaching growth through connectivity. we hope you ll love using kkp bhadli app to connect with you community.",
    ],
    images: [
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/KKPBHADLI/project-ss-1.png",
      "https://portfolio-neoverce.s3.ap-south-1.amazonaws.com/KKPBHADLI/project-ss-2.png",
    ],
    icons: [
      {
        image: "https://work.neoverce.com/assets/React-icon-f2cadfd0.svg",
        links: "https://reactnative.dev/",
        IconLabel: "React Native",
      },
      {
        image: "https://work.neoverce.com/assets/Node.js_logo-dc8800bf.svg",
        links: "https://nodejs.org/",
        IconLabel: "Node JS",
      },
    ],
  },
];

export const projectsView = [
  {
    name: "Kloo Website",
    title: "Kloo",
    image: Thumbnail1,
    color: "#fff",
    link: "kloo",
  },
  {
    name: "NJCapital",
    title: "Loan Website",
    image: Thumbnail,
    color: "#fff",
    link: "NJCapital",
  },
  {
    name: "Gorewear",
    title: "E-Shopping Website",
    image: Thumbnail10,
    color: "#fff",
    link: "gorewear",
  },
  // {
  //   name: "Safespace",
  //   title: "Application",
  //   image: Thumbnail12,
  //   color: "#08111f",
  //   link: "safespace",
  // },
  {
    name: "Tripigos",
    title: "Travel Website",
    image: Thumbnail2,
    color: "#08111f",
    link: "tripigos",
  },
  {
    name: "Crom",
    title: "Mobile Application",
    image: Thumbnail4,
    color: "#fff",
    link: "crom",
  },
  {
    name: "Flex League",
    title: "Mobile Application",
    image: Thumbnail5,
    color: "#fff",
    link: "flex-league",
  },
  {
    name: "Boomio",
    title: "Website",
    image: Thumbnail6,
    color: "#08111f",
    link: "boomio",
  },
  {
    name: "Meeko",
    title: "Kids Learning Website",
    image: Thumbnail7,
    color: "#fff",
    link: "meeko",
  },
  {
    name: "Sitka",
    title: "E-Shopping Website",
    image: Thumbnail9,
    color: "#fff",
    link: "sitka",
  },
  {
    name: "BeLiving",
    title: "Living Room Finder Website",
    image: Thumbnail8,
    color: "#08111f",
    link: "beLiving",
  },
  {
    name: "MT-Hood",
    title: "E-Shopping Website",
    image: Thumbnail11,
    color: "#08111f",
    link: "mtHood",
  },
  // {
  //   name: 'Yoloh',
  //   title: 'Online Insurance',
  //   image: Thumbnail13,
  //   color: '#fff',
  //   link: 'yoloh',
  // },
  // {
  //   name: 'Dine N Dash',
  //   title: 'Admin Panel',
  //   image: Thumbnail14,
  //   color: '#fff',
  //   link: 'dineNdash',
  // },
  {
    name: "KKP-Bhadli",
    title: "Family Application",
    image: Thumbnail15,
    color: "#08111f",
    link: "KKPBhadli",
  },
];

export const PROJECT_ESTIMATOR = [
  {
    question: "Choose your **industry**",
    description: "Choose a business domain for your project below",
    type: "chip",
    key: "industries",
    option: "industries",
    column: 12,
    summaryTitle: "Industry",
    summaryIcon: <LiaIndustrySolid />,
  },
  {
    question: "Project **length**",
    description: "Choose a Project length.",
    type: "slider",
    key: "duration",
    option: {
      20: "< 6 Month",
      40: "< 9 Month",
      60: "< 1 Year",
      80: "< 1.5 Year",
      100: "> 2 Year",
    },
    column: 12,
    summaryTitle: "Project Length",
    summaryIcon: <FaProjectDiagram />,
  },
  {
    question: "Layout **Complexity**",
    description: "Choose a Project Complexity.",
    type: "radio",
    key: "complexity",
    option: [
      { title: "Low", _id: "low" },
      { title: "Medium", _id: "medium" },
      { title: "High", _id: "high" },
    ],
    column: 6,
    summaryTitle: "Complexity",
    summaryIcon: <TbTopologyComplex />,
  },
  {
    question: "Project **Engagement**",
    description: "Choose a Project engagement.",
    type: "radio-description",
    key: "engagement",
    option: "engagement",
    column: 6,
    summaryTitle: "Engagement",
    summaryIcon: <MdOutlineWorkOutline />,
  },
  {
    question: "Target **Platform**",
    description: "Choose a Platform.",
    type: "chip",
    key: "platform",
    option: "platform",
    column: 12,
    summaryTitle: "Platform",
    summaryIcon: <GiPlatform />,
  },
  {
    question: "Do You Need a **Design** Team?",
    description: "",
    type: "radio",
    key: "designTeam",
    option: [
      { title: "Yes", _id: true },
      { title: "No", _id: false },
    ],
    column: 12,
    summaryTitle: "Design Team",
    summaryIcon: <MdOutlineDesignServices />,
  },
  {
    question: "Do You Need **AI, ML, or SEO/Marketing** Expertise?",
    description: "",
    type: "radio",
    option: [
      { title: "Yes", _id: true },
      { title: "No", _id: false },
    ],
    key: "marketingExpertise",
    column: 12,
    summaryTitle: "Marketing",
    summaryIcon: <AiOutlineNotification />,
  },
];

export const TestimonialData = [
  {
    text: "Working with this team of expert guys was a blast!! They have a strong knowledge on Web-Development and 3D and were open to do r&d with few experimental ideas. I’d work with him again in the future, and recommend them to everyone. Great Experience!",
    name: "Zeno Saviour",
    location: "Sydney, Australia",
  },
  {
    text: "Neoverce IT Solutions is an excellent team of Developers and management people. We wanted to develop and add features to our realistic project. Once the requirements are made clear, they developed quite independently and delivered good quality work on time.",
    name: "Kongara",
    location: "San Jose, United States",
  },
  {
    text: "Neoverce IT Solutions has been very reasonable and trustworthy for me to make my product with them. They are skillful people and keen eye on every details of the instructions and development. They have made my vision to life. I’m so grateful for that. 10/10 for these guys.",
    name: "Adomas",
    location: "Vilnius, Lithuania",
  },
  {
    text: "Neoverce IT Solutions was very professional and efficient. We were stuck on the development midway. They made that possible brilliantly and very time/cost effectively. Thumbs up to the all team!!",
    name: "Tristan Bochu",
    location: "Boulogne-Billancourt, France",
  },
  {
    text: "Working with this team of expert guys was a blast!! They have a strong knowledge on Web-Development and 3D and were open to do r&d with few experimental ideas. I’d work with him again in the future, and recommend them to everyone. Great Experience!",
    name: "Zeno Saviour",
    location: "Sydney, Australia",
  },
  {
    text: "Neoverce IT Solutions is an excellent team of Developers and management people. We wanted to develop and add features to our realistic project. Once the requirements are made clear, they developed quite independently and delivered good quality work on time.",
    name: "Kongara",
    location: "San Jose, United States",
  },
];
export const services = [
  {
    title: "Custom Frontend Development",
    description:
      "We specialize in designing custom interfaces that perfectly align with your brand identity and drive your business success. Our frontend development services are tailored to your unique needs and offer:",
    points: [
      "Intuitive navigation for user-friendly experience",
      "High responsiveness for seamless performance on any device",
      "Unique, standout designs that help your platform differentiate itself from competitors",
    ],
  },
  {
    title: "Single-Page Applications (SPA)",
    description:
      "Our SPAs ensure lightning-fast performance and smooth transitions, enhancing user satisfaction. Using modern frameworks, we create apps that deliver optimal functionality while reducing load times and improving efficiency.",
    points: [
      "Enhanced performance with minimal load times",
      "Fluid transitions for a seamless user journey",
      "Cutting-edge features using React, Vue.js, or Angular",
    ],
  },
  {
    title: "CMS Customizations",
    description:
      "We customize CMS platforms like WordPress, Drupal, and Joomla to match your specific business needs. From custom themes to unique plugins, we ensure your CMS is optimized for performance, scalability, and user engagement.",
    points: [
      "Scalability and flexibility for evolving business needs",
      "Optimized performance for large-scale content management",
      "A highly customized, branded experience",
    ],
  },
  {
    title: "Frontend Consulting",
    description:
      "Need guidance on your frontend architecture? We can help you make informed decisions about your frontend architecture and technology stack. Our experts guide you in adopting the best practices and technologies for your project’s success.",
    points: [
      "Technology stack selection",
      "Best practices for frontend architecture",
      "Strategies to maximize your application’s impact",
    ],
  },
  {
    title: "Frontend Team Augmentation",
    description:
      "Our team augmentation services provide you with skilled frontend developers to scale your projects efficiently. Whether for a short-term need or a long-term engagement, we seamlessly integrate with your in-house team to deliver.",
    points: [
      "Boost productivity",
      "Meet tight deadlines",
      "Ensure high-quality results",
    ],
  },
  {
    title: "Cross-Platform Development",
    description:
      "We develop applications that perform flawlessly on any device, ensuring your users have consistent and delightful interactions whether on desktop, mobile, or tablet. Our cross-platform solutions save time and costs while maximizing reach.",
    points: [
      "Consistent functionality on desktops, tablets, and mobile devices",
      "Increased reach and engagement with diverse audiences",
      "Cost savings through unified development processes",
    ],
  },
  {
    title: "Microfrontend Architecture",
    description:
      "We design microfrontend architectures that allow for independent deployment of frontend components, enabling better scalability and maintainability for complex applications",
    points: [
      "Enable independent development and deployment of features",
      "Improve maintainability and scalability",
      "Ensure efficient team collaboration on large-scale applications",
    ],
  },
  {
    title: "Frontend Maintenance and Support",
    description:
      "We provide continuous support to keep your application secure, updated, and optimized. With regular performance checks, timely updates, and 24/7 assistance, we ensure your frontend remains a step ahead of the competition.",
    points: [
      "Ongoing security and performance optimization",
      "Timely updates and feature enhancements",
      "A seamless user experience, even post-deployment",
    ],
  },
];
export const backendServices = [
  {
    title: "Custom Backend Solutions",
    description:
      "Our experienced developers create tailored backend solutions that align with your business goals. Whether you need a web application or a mobile backend, we craft robust solutions that meet your specific requirements.",
    points: [
      "Scalable architecture",
      "Secure API development",
      "High-performance database integration",
    ],
  },
  {
    title: "API Development and Integration",
    description:
      "We specialize in developing and integrating APIs that allow seamless communication between systems, ensuring your application can operate efficiently and securely.",
    points: [
      "RESTful API development",
      "GraphQL API integration",
      "Third-party API integration",
    ],
  },
  {
    title: "Database Management Solutions",
    description:
      "From designing efficient data models to managing databases, our developers ensure your backend handles data securely and efficiently.",
    points: [
      "SQL and NoSQL database integration",
      "Real-time data processing",
      "Data migration and optimization",
    ],
  },
  {
    title: "Security and Compliance",
    description:
      "We prioritize security in all our backend development services, ensuring that your application meets industry standards and is protected against potential threats.",
    points: ["API Security", "Database Security", "Compliance with Standards"],
  },
  {
    title: "Backend Consulting",
    description:
      "We provide strategic guidance to optimize and enhance your application's architecture. From small startups to large enterprises, our goal is to create scalable, secure, and future-proof backend solutions.",
    points: [
      "Craft scalable and efficient backend structures",
      "Recommend and implement the best-suited frameworks",
      "Analyze and fine-tune backend systems",
    ],
  },
  {
    title: "Cloud-based Backend Service",
    description:
      "Our expert developers specialize in creating cloud-native backend solutions designed to support modern, data-driven applications, offering scalable, on-demand processing without the need to manage infrastructure.",
    points: [
      "AWS, Azure, and Google Cloud Integration",
      "Microservices architecture",
      "Serverless backend solutions",
    ],
  },
  {
    title: "Server Side Logic Development",
    description:
      "Our backend developers excel in creating custom server-side logic that handles complex operations, processes, and data manipulation efficiently, our team ensures that every piece of logic is optimized for performance and accuracy.",
    points: [
      "Business Logic Implementation",
      "Build and manage server-side APIs",
      "Handling server-side data transformations",
    ],
  },
  {
    title: "Support and Maintenance",
    description:
      "Our backend support and maintenance services ensure that your business runs smoothly with minimal downtime and maximum uptime. We continuously track the health of your backend systems and deploy solutions proactively to prevent issues.",
    points: [
      "24/7 Backend Monitoring",
      "Timely resolution of bugs, security patches, and system updates",
      "Regular performance tuning",
    ],
  },
];
export const databaseServices = [
  {
    title: "Custom Database Development",
    description:
      "We design and implement custom databases that fit seamlessly with your business operations, providing secure, efficient, and flexible solutions for managing your critical data. Our services include:",
    points: [
      "Custom database schema design",
      "High performance, secure storage and retrieval of data",
      "Optimized queries for fast response times and efficient data handling",
    ],
  },
  {
    title: "Database Migration Services",
    description:
      "Whether you're moving from legacy systems or scaling your operations, we assist with smooth database migrations. Our migration strategies ensure no data loss, minimal downtime, and optimal performance after the migration.",
    points: [
      "Safe, secure data transfers to new platforms",
      "Proven methodologies to minimize downtime",
      "Scalability for future growth and flexibility",
    ],
  },
  {
    title: "Cloud-Based Databases",
    description:
      "We help you take advantage of cloud computing by developing and optimizing databases that operate seamlessly on platforms such as AWS, Google Cloud, and Microsoft Azure. Our cloud database solutions include:",
    points: [
      "Reduced infrastructure costs with cloud solutions",
      "Automated backups and disaster recovery plans",
      "Highly available and fault-tolerant systems",
    ],
  },
  {
    title: "Database Optimization and Performance Tuning",
    description:
      "A slow database can hinder your application’s performance. We provide database optimization services to improve speed, reduce query times, and ensure your applications run smoothly even under heavy loads.",
    points: [
      "Advanced indexing and query optimization techniques",
      "Data partitioning and sharding to improve performance",
      "Routine health checks and performance assessments",
    ],
  },
  {
    title: "Database Consulting",
    description:
      "Not sure which database technology fits your needs? Our expert consultants offer guidance on selecting the right database system, architecture, and technologies. We provide:",
    points: [
      "Expert advice on selecting SQL, NoSQL, or NewSQL databases",
      "Tailored strategies for database architecture",
      "Best practices for data management and optimization",
    ],
  },
  {
    title: "Database Security Solutions",
    description:
      "Security is critical to any database. We implement robust security measures to safeguard your data, preventing unauthorized access, data breaches, and potential vulnerabilities.",
    points: [
      "End-to-end encryption of sensitive data",
      "Implementing access control mechanisms",
      "Routine vulnerability assessments and security updates",
    ],
  },
  {
    title: "NoSQL Database Development",
    description:
      "For applications requiring flexible and scalable data storage, we leverage NoSQL technologies like MongoDB, Cassandra, and Couchbase. These solutions are ideal for:",
    points: [
      "Handling unstructured or semi-structured data",
      "Scalability and performance for high-traffic applications",
      "Efficient real-time data processing",
    ],
  },
  {
    title: "Database Integration",
    description:
      "We integrate databases with your existing systems, including CRMs, ERPs, and other enterprise platforms, to ensure seamless data flow across all business functions.",
    points: [
      "API-based integrations for secure data exchanges",
      "Syncing with cloud-based databases",
      "Ensuring data consistency and accuracy across platforms",
    ],
  },
];
export const uiuxServices = [
  {
    title: "User-Centric Design Approach",
    description:
      "We focus on creating designs that make user interactions effortless. By putting your users at the center of the design process, we ensure that every element is optimized for accessibility, ease of use, and functionality.",
    points: [
      "Intuitive User Interfaces for easy navigation",
      "Responsive Designs for an optimal experience on all devices",
      "Innovative Visual Designs to help your platform stand out from competitors",
    ],
  },
  {
    title: "SEO-Optimized UI/UX Designs",
    description:
      "Our UI/UX design team takes SEO best practices into account during the design process, ensuring your designs not only engage users but also enhance search engine rankings.",
    points: [
      "SEO-Friendly Designs to improve page speed and usability",
      "Optimized Image Sizes for faster load times",
      "Accessible Navigation & User Flows to boost SEO rankings",
    ],
  },
  {
    title: "User Journey Mapping and Research",
    description:
      "Understanding the path users take through your platform is vital for providing a smooth, engaging experience. Our team uses data-driven insights to map user journeys, ensuring your interface is aligned with user expectations, behaviors, and needs.",
    points: [
      "User persona creation to align with target audience",
      "Data analysis to refine the user journey",
      "Focus on reducing friction points and enhancing user satisfaction",
    ],
  },
  {
    title: "Prototyping and Wireframing",
    description:
      "We create detailed wireframes and prototypes to help you visualize your design concepts before development begins. This allows you to review, iterate, and validate your design early on in the process, ensuring a final product that aligns perfectly with your vision.",
    points: [
      "Interactive prototypes to simulate real-world usage",
      "Wireframes to define structure, content, and functionality",
      "Early validation to minimize design changes later",
    ],
  },
  {
    title: "UI/UX Consulting",
    description:
      "Not sure where to start with your UI/UX design project? Our experts are here to provide tailored consulting services. Whether you're refining your current interface or designing from scratch, we help you define your objectives, select the right tools, and implement best practices to create a successful user experience.",
    points: [
      "Technology stack selection for UI/UX tools",
      "Design audits to optimize existing user experiences",
      "Strategic planning to ensure your design meets business goals",
    ],
  },
  {
    title: "UI/UX Team Augmentation",
    description:
      "Our team augmentation services give you access to skilled UI/UX designers who can integrate seamlessly with your in-house team. Whether for a short-term project or long-term collaboration, our experts help you scale up your design efforts without compromising quality.",
    points: [
      "Increase design capacity and speed",
      "Fill specific skill gaps with expert designers",
      "Maintain high-quality design output with experienced professionals",
    ],
  },
  {
    title: "Cross-Platform UI/UX Design",
    description:
      "We design UI/UX experiences that work flawlessly across different platforms, ensuring a consistent experience whether on desktop, tablet, or mobile. Our cross-platform approach saves time and costs while maintaining a cohesive brand presence.",
    points: [
      "Consistent experience across web and mobile platforms",
      "Simplified workflows to save development time and cost",
      "Optimized user interface that adapts to any device",
    ],
  },
  {
    title: "UI/UX Design Maintenance and Support",
    description:
      "We offer ongoing support to keep your UI/UX design fresh, secure, and updated. With regular audits, updates, and performance checks, we ensure that your design evolves to meet the changing needs of your users and business.",
    points: [
      "Ongoing updates and design refinements",
      "Performance monitoring for optimal user interaction",
      "Continuous support to keep your design competitive",
    ],
  },
];
export const mobileAppServices = [
  {
    title: "Cross-Platform Mobile App Development",
    description:
      "Save time and costs with our cross-platform solutions. We use tools like Flutter and React Native to build apps that work flawlessly on both iOS and Android, ensuring:",
    points: [
      "Consistent performance across all devices",
      "Maximum reach and audience engagement",
      "Cost-efficiency with a unified development process",
    ],
  },
  {
    title: "Native Mobile App Development",
    description:
      "For businesses requiring optimized performance and deep platform integration, we develop native apps using Swift for iOS and Kotlin for Android. Benefits include:",
    points: [
      "Enhanced performance and reliability",
      "Seamless integration with device-specific features",
      "Optimized UI/UX for platform-specific designs",
    ],
  },
  {
    title: "Enterprise Mobile App Development",
    description:
      "We create secure, scalable, and high-performance enterprise apps to streamline workflows and enhance productivity. Our enterprise solutions provide:",
    points: [
      "Custom integrations with existing systems.",
      "Enhanced security for sensitive data.",
      "Scalability for evolving business requirements.",
    ],
  },
  {
    title: "Wearable Application Development",
    description:
      "We specialize in creating innovative apps for wearable devices like smartwatches, fitness trackers, and other IoT-enabled wearables. Our team is always up-to-date with the latest trends and technologies to help you engage users with intuitive experiences.",
    points: [
      "Sync with smartphones for enhanced functionality.",
      "Real-Time Notifications",
      "Simple, intuitive design for small screens",
    ],
  },
  {
    title: "Web-App Development",
    description:
      "In addition to mobile apps, Neoverce offers comprehensive Web App Development Services to provide you with flexible, scalable, and cross-platform web-based applications",
    points: [
      "Tailored solutions that align with your business processes",
      "Leverage the cloud for scalability and enhanced data storage",
      "Progressive Web Apps",
    ],
  },
  {
    title: "Mobile App Consulting",
    description:
      "We offer expert advice on app strategy, platform selection, architecture, user experience, and technology stacks, helping you transform your ideas into a viable and successful mobile app.",
    points: [
      "Get data-driven recommendations.",
      "Platform and Technology recommendations",
      "Gain insights into the competitive landscape and market trends",
    ],
  },
  {
    title: "Social Networking & Chat App Development",
    description:
      "Leverage the power of social connectivity with custom social networking and messaging apps. Our expert application developer team creates solutions that facilitate interaction, sharing, and user engagement in an intuitive and scalable manner.",
    points: [
      "Building a community platform or a private messaging app",
      "Social Integration with Facebook, Twitter, and Google",
      "Security features like end-to-end encryption",
    ],
  },
  {
    title: "App UI/UX Design",
    description:
      "Our design team specializes in creating visually appealing and easy-to-use interfaces, we focus on designing clean, intuitive layouts that are responsive across various devices and screen sizes.",
    points: [
      "User-Centered Design Approach",
      "High-Fidelity Wireframes and Prototypes",
      "Usability Testing for Optimal Performance",
    ],
  },
];
export const cloudServices = [
  {
    title: "Cloud Migration Service",
    description:
      "Our team ensures a smooth, secure, and efficient transition whether you are migrating from legacy systems or optimizing your existing cloud setup, we help you move your data, applications, and services with minimal disruption.",
    points: [
      "Minimize downtime and data loss during migration",
      "Custom-Tailored Solutions",
      "Post migration support",
    ],
  },
  {
    title: "Cloud Infrastructure Management",
    description:
      "We focus on scalability, performance, and security to ensure your cloud environment operates smoothly and cost-effectively, so you can focus on what matters most i.e. growing your business.",
    points: [
      "Ensuring uptime and optimal performance",
      "Efficient resource allocation to reduce unnecessary expenses",
      "Maintaining a secure and compliant infrastructure",
    ],
  },
  {
    title: "Cloud Microservices Architecture",
    description:
      "We break down your monolithic applications into smaller, manageable components that are easier to develop, deploy, and scale. This approach enhances agility, reduces development costs, and improves application performance.",
    points: [
      "Deploy independent services without downtime",
      "Scale individual services as needed",
      "Minimize risk with fault-tolerant services",
    ],
  },
  {
    title: "Cloud Strategy and Consulting",
    description:
      "Our team of experts will work with you to develop a customized cloud strategy that aligns with your business goals, helping you make informed decisions and streamline your cloud adoption process.",
    points: [
      "Design a cloud strategy that suits your needs",
      "Maximize efficiency and performance",
      "Benefit from our years of cloud experience",
    ],
  },
  {
    title: "Cloud Backup Service",
    description:
      "We provide secure, automated, and scalable backup solutions, ensuring your data is always safe and can be quickly restored in case of unexpected events.",
    points: [
      "No manual intervention needed",
      "Grow your backup solution as your data increases",
      "Swift data recovery to minimize downtime",
    ],
  },
  {
    title: "Cloud Based SaaS Development",
    description:
      "Our team specializes in building software-as-a-service (SaaS) applications that are hosted in the cloud, giving your users access to powerful tools anytime, anywhere, on any device.",
    points: [
      "Tailored SaaS apps to meet your business needs",
      "Easily scale your SaaS app as your customer base grows",
      "Cloud hosting ensures worldwide availability",
    ],
  },
  {
    title: "Cloud Compliance and Security",
    description:
      "In today’s digital landscape, cloud security and compliance are non-negotiable. We ensure your cloud infrastructure adheres to industry regulations while safeguarding sensitive data from threats.",
    points: [
      "Advanced encryption and secure access controls",
      "Regulatory compliance like GDPR, HIPAA, and more",
      "Threat detection & prevention",
    ],
  },
  {
    title: "Cloud System Integration",
    description:
      "We ensure seamless integration between your cloud applications, legacy systems, and third-party tools, providing a unified, efficient workflow that enhances productivity.",
    points: [
      "Link your cloud with other enterprise systems",
      "Streamline operations for improved efficiency",
      "Simplify your IT ecosystem with a unified cloud infrastructure",
    ],
  },
];
export const aimlServices = [
  {
    title: "AI/ML Integration and Development",
    description:
      "We offer end-to-end AI/ML development services, from model creation to deployment, enabling businesses to solve complex problems, we also help develop custom APIs to integrate AI/ML systems into your existing applications and workflows smoothly.",
  },
  {
    title: "Generative AI Consulting",
    description:
      "Generative AI is a game-changer in the world of innovation. Whether it’s content generation, product design, or virtual environments, we help our clients harness the full potential of Generative AI by providing personalized consulting services.",
  },
  {
    title: "Data Engineering",
    description:
      "To make better business decisions, you need reliable, structured and clean data. Our smart AI agents implement efficient storage systems that ensure your data is organized and easily retrievable, from on-premise to cloud solutions.",
  },
  {
    title: "Machine Learning Model Creation",
    description:
      "Our team builds efficient machine learning models designed to solve your specific business challenges. We handle everything from data cleaning and preprocessing to model selection, training, and deployment, ensuring high-quality results.",
  },
  {
    title: "Predictive Modeling",
    description:
      "We create predictive models that help you plan for future scenarios, giving you the confidence to make proactive decisions. Using our models, identify the potential risks before they materialize, from financial risk to operational challenges.",
  },
  {
    title: "AI-Driven Data Analytics",
    description:
      "With AI-powered dashboards, we assist clients in turning complex data into actionable intelligence. From customer insights to operational efficiency, our analytics solutions help businesses make smarter decisions and eliminate inaccuracies and gaps.",
  },
  {
    title: "AI Chatbots and Virtual Assistants",
    description:
      "We build custom AI chatbots that understand natural language, ensuring meaningful conversations with your customers. It can handle everything from answering FAQs to processing transactions, allowing your team to focus on higher-value tasks.",
  },
  {
    title: "Fraud Detection & Security",
    description:
      "We implement AI algorithms that monitor transactions, user activity, and system behavior. With the help of our solutions, you can prevent your business from security breaches, protect sensitive data, and safeguard your reputation.",
  },
  {
    title: "Automation Solution",
    description:
      "Our automation services enable you to streamline processes, reduce human error, and free up resources for more strategic tasks. From customer onboarding to post-sales support, automate entire workflows efficiently.",
  },
];
export const technologies = [
  {
    name: "React JS",
    src: "https://cdn.worldvectorlogo.com/logos/react-2.svg",
    alt: "React JS Logo",
  },
  {
    name: "Angular",
    src: "https://cdn.worldvectorlogo.com/logos/angular-icon-1.svg",
    alt: "Angular Logo",
  },
  {
    name: "Next.js",
    src: "https://cdn.worldvectorlogo.com/logos/nextjs-2.svg",
    alt: "Next.js Logo",
  },
  {
    name: "Vue.js",
    src: "https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg",
    alt: "Vue.js Logo",
  },
  {
    name: "Svelte",
    src: "https://cdn.worldvectorlogo.com/logos/svelte-1.svg",
    alt: "Svelte Logo",
  },
  {
    name: "Tailwind CSS",
    src: "https://cdn.worldvectorlogo.com/logos/tailwindcss.svg",
    alt: "Tailwind CSS Logo",
  },
  {
    name: "Bootstrap",
    src: "https://cdn.worldvectorlogo.com/logos/bootstrap-5-1.svg",
    alt: "Bootstrap Logo",
  },
  {
    name: "TypeScript",
    src: "https://cdn.worldvectorlogo.com/logos/typescript.svg",
    alt: "TypeScript Logo",
  },
  {
    name: "JavaScript",
    src: "https://cdn.worldvectorlogo.com/logos/logo-javascript.svg",
    alt: "JavaScript Logo",
  },
  {
    name: "Redux",
    src: "https://cdn.worldvectorlogo.com/logos/redux.svg",
    alt: "Redux Logo",
  },
  {
    name: "HTML5",
    src: "https://cdn.worldvectorlogo.com/logos/html-1.svg",
    alt: "HTML5 Logo",
  },
  {
    name: "CSS3",
    src: "https://cdn.worldvectorlogo.com/logos/css-3.svg",
    alt: "CSS3 Logo",
  },
  {
    name: "SCSS / Sass",
    src: "https://cdn.worldvectorlogo.com/logos/sass-1.svg",
    alt: "Sass Logo",
  },
  {
    name: "Material UI",
    src: "https://cdn.worldvectorlogo.com/logos/material-ui-1.svg",
    alt: "Material UI Logo",
  },
  {
    name: "Framer Motion",
    src: "https://cdn.worldvectorlogo.com/logos/framer-motion.svg",
    alt: "Framer Motion Logo",
  },
  {
    name: "jQuery",
    src: "https://cdn.worldvectorlogo.com/logos/jquery-4.svg",
    alt: "jQuery Logo",
  },
  {
    name: "ESLint",
    src: "https://cdn.worldvectorlogo.com/logos/eslint-1.svg",
    alt: "ESLint Logo",
  },
  {
    name: "Webpack",
    src: "https://cdn.worldvectorlogo.com/logos/webpack-icon.svg",
    alt: "Webpack Logo",
  },
  {
    name: "Vite",
    src: "https://cdn.worldvectorlogo.com/logos/vitejs.svg",
    alt: "Vite Logo",
  },
  {
    name: "Gatsby",
    src: "https://cdn.worldvectorlogo.com/logos/gatsby.svg",
    alt: "Gatsby Logo",
  },
];
export const backendTechnologies = [
  {
    name: "Node.js",
    src: "https://cdn.worldvectorlogo.com/logos/nodejs-icon.svg",
    alt: "Node.js Logo",
  },
  {
    name: "Express.js",
    src: "https://cdn.worldvectorlogo.com/logos/express-109.svg",
    alt: "Express.js Logo",
  },
  {
    name: "Django",
    src: "https://cdn.worldvectorlogo.com/logos/django.svg",
    alt: "Django Logo",
  },
  {
    name: "Flask",
    src: "https://cdn.worldvectorlogo.com/logos/flask.svg",
    alt: "Flask Logo",
  },
  {
    name: "Spring Boot",
    src: "https://cdn.worldvectorlogo.com/logos/spring-3.svg",
    alt: "Spring Boot Logo",
  },
  {
    name: "Laravel",
    src: "https://cdn.worldvectorlogo.com/logos/laravel-2.svg",
    alt: "Laravel Logo",
  },
  {
    name: "Ruby on Rails",
    src: "https://cdn.worldvectorlogo.com/logos/rails-1.svg",
    alt: "Ruby on Rails Logo",
  },
  {
    name: "ASP.NET Core",
    src: "https://cdn.worldvectorlogo.com/logos/microsoft-net.svg",
    alt: "ASP.NET Core Logo",
  },
  {
    name: "FastAPI",
    src: "https://cdn.worldvectorlogo.com/logos/fastapi.svg",
    alt: "FastAPI Logo",
  },
  {
    name: "GraphQL",
    src: "https://upload.wikimedia.org/wikipedia/commons/1/17/GraphQL_Logo.svg",
    alt: "GraphQL Logo",
  },
  {
    name: "NestJS",
    src: "https://cdn.worldvectorlogo.com/logos/nestjs.svg",
    alt: "NestJS Logo",
  },
  {
    name: "MongoDB",
    src: "https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg",
    alt: "MongoDB Logo",
  },
  {
    name: "PostgreSQL",
    src: "https://cdn.worldvectorlogo.com/logos/postgresql.svg",
    alt: "PostgreSQL Logo",
  },
  {
    name: "MySQL",
    src: "https://upload.wikimedia.org/wikipedia/en/d/dd/MySQL_logo.svg",
    alt: "MySQL Logo",
  },
  {
    name: "Redis",
    src: "https://cdn.worldvectorlogo.com/logos/redis.svg",
    alt: "Redis Logo",
  },
  {
    name: "Prisma",
    src: "https://cdn.worldvectorlogo.com/logos/prisma-3.svg",
    alt: "Prisma Logo",
  },
  {
    name: "Docker",
    src: "https://cdn.worldvectorlogo.com/logos/docker.svg",
    alt: "Docker Logo",
  },
  {
    name: "Nginx",
    src: "https://cdn.worldvectorlogo.com/logos/nginx.svg",
    alt: "Nginx Logo",
  },
];
export const databaseTechnologies = [
  {
    name: "MongoDB",
    src: "https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg",
    alt: "MongoDB Logo",
  },
  {
    name: "PostgreSQL",
    src: "https://cdn.worldvectorlogo.com/logos/postgresql.svg",
    alt: "PostgreSQL Logo",
  },
  {
    name: "MySQL",
    src: "https://upload.wikimedia.org/wikipedia/en/d/dd/MySQL_logo.svg",
    alt: "MySQL Logo",
  },
  {
    name: "Redis",
    src: "https://cdn.worldvectorlogo.com/logos/redis.svg",
    alt: "Redis Logo",
  },
  {
    name: "SQLite",
    src: "https://cdn.worldvectorlogo.com/logos/sqlite.svg",
    alt: "SQLite Logo",
  },
  {
    name: "Firebase",
    src: "https://cdn.worldvectorlogo.com/logos/firebase-1.svg",
    alt: "Firebase Logo",
  },
  {
    name: "DynamoDB",
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fd/DynamoDB.png",
    alt: "DynamoDB Logo",
  },
  {
    name: "Prisma",
    src: "https://cdn.worldvectorlogo.com/logos/prisma-3.svg",
    alt: "Prisma Logo",
  },
  {
    name: "Oracle DB",
    src: "https://cdn.worldvectorlogo.com/logos/oracle.svg",
    alt: "Oracle DB Logo",
  },
];
export const uiuxTechnologies = [
  {
    name: "Figma",
    src: "https://api.prolanceit.com/media/newTechnologies/48/Figma.svg",
    alt: "Figma Logo",
  },
  {
    name: "Adobe XD",
    src: "https://cdn.worldvectorlogo.com/logos/adobe-xd-2.svg",
    alt: "Adobe XD Logo",
  },
  {
    name: "Sketch",
    src: "https://cdn.worldvectorlogo.com/logos/sketch-2.svg",
    alt: "Sketch Logo",
  },
  {
    name: "InVision",
    src: "https://cdn.worldvectorlogo.com/logos/invision.svg",
    alt: "InVision Logo",
  },
  {
    name: "Adobe Illustrator",
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fb/Adobe_Illustrator_CC_icon.svg",
    alt: "Adobe Illustrator Logo",
  },
  {
    name: "Adobe Photoshop",
    src: "https://cdn.worldvectorlogo.com/logos/adobe-photoshop-2.svg",
    alt: "Adobe Photoshop Logo",
  },
  {
    name: "Framer",
    src: "https://framerusercontent.com/images/s8byoJvwTkn7Gm2jKWNdTPv9F8Q.svg",
    alt: "Framer Logo",
  },
  {
    name: "Zeplin",
    src: "https://cdn.worldvectorlogo.com/logos/zeplin.svg",
    alt: "Zeplin Logo",
  },
  {
    name: "Axure RP",
    src: "https://cdn.brandfetch.io/id99STEpoQ/theme/dark/symbol.svg?c=1bxid64Mup7aczewSAYMX&t=1699345845305",
    alt: "Axure RP Logo",
  },
  {
    name: "Balsamiq",
    src: "https://api.prolanceit.com/media/newTechnologies/51/Balsamiq.svg",
    alt: "Balsamiq Logo",
  },
  {
    name: "Canva",
    src: "https://cdn.worldvectorlogo.com/logos/canva-1.svg",
    alt: "Canva Logo",
  },
  {
    name: "Marvel App",
    src: "https://cdn.worldvectorlogo.com/logos/marvel.svg",
    alt: "Marvel App Logo",
  },
  {
    name: "UXPin",
    src: "https://cdn.brandfetch.io/idSeIuHbGs/w/400/h/400/theme/dark/icon.jpeg?c=1bxid64Mup7aczewSAYMX&t=1744099008614",
    alt: "UXPin Logo",
  },
  {
    name: "Proto.io",
    src: "https://cdn.worldvectorlogo.com/logos/proto-io.svg",
    alt: "Proto.io Logo",
  },
  {
    name: "LottieFiles",
    src: "https://cdn.worldvectorlogo.com/logos/lottiefiles.svg",
    alt: "LottieFiles Logo",
  },
];
export const mobileAppTechnologies = [
  {
    name: "React Native",
    src: "https://cdn.worldvectorlogo.com/logos/react-2.svg",
    alt: "React Native Logo",
  },
  {
    name: "IOS",
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    alt: "IOS Logo",
  },
  {
    name: "Flutter",
    src: "https://cdn.worldvectorlogo.com/logos/flutter.svg",
    alt: "Flutter Logo",
  },
  {
    name: "Swift",
    src: "https://cdn.worldvectorlogo.com/logos/swift-15.svg",
    alt: "Swift Logo",
  },
  {
    name: "Kotlin",
    src: "https://cdn.worldvectorlogo.com/logos/kotlin-1.svg",
    alt: "Kotlin Logo",
  },
  {
    name: "Java",
    src: "https://cdn.worldvectorlogo.com/logos/java-4.svg",
    alt: "Java Logo",
  },
  {
    name: "Dart",
    src: "https://cdn.worldvectorlogo.com/logos/dart.svg",
    alt: "Dart Logo",
  },
  {
    name: "Android Studio",
    src: "https://cdn.worldvectorlogo.com/logos/android-logomark.svg",
    alt: "Android Studio Logo",
  },
  {
    name: "Firebase",
    src: "https://cdn.worldvectorlogo.com/logos/firebase-1.svg",
    alt: "Firebase Logo",
  },
  {
    name: "Unity",
    src: "https://cdn.worldvectorlogo.com/logos/unity-69.svg",
    alt: "Unity Logo",
  },
  {
    name: "Expo",
    src: "https://cdn.worldvectorlogo.com/logos/expo-1.svg",
    alt: "Expo Logo",
  },
];
export const cloudTechnologies = [
  {
    name: "Amazon Web Services (AWS)",
    src: "https://cdn.worldvectorlogo.com/logos/aws-2.svg",
    alt: "AWS Logo",
  },
  {
    name: "Azure",
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Microsoft_Azure.svg",
    alt: "Azure Logo",
  },
  {
    name: "Google Cloud Platform (GCP)",
    src: "https://cdn.worldvectorlogo.com/logos/google-cloud-1.svg",
    alt: "Google Cloud Platform Logo",
  },
  {
    name: "IBM Cloud",
    src: "https://cdn.worldvectorlogo.com/logos/ibm-cloud-1.svg",
    alt: "IBM Cloud Logo",
  },
  {
    name: "Oracle Cloud",
    src: "https://cdn.worldvectorlogo.com/logos/oracle.svg",
    alt: "Oracle Cloud Logo",
  },
  {
    name: "Heroku",
    src: "https://cdn.worldvectorlogo.com/logos/heroku-4.svg",
    alt: "Heroku Logo",
  },
  {
    name: "Firebase",
    src: "https://cdn.worldvectorlogo.com/logos/firebase-1.svg",
    alt: "Firebase Logo",
  },
  {
    name: "Cloudflare",
    src: "https://cdn.worldvectorlogo.com/logos/cloudflare-1.svg",
    alt: "Cloudflare Logo",
  },
  {
    name: "Netlify",
    src: "https://cdn.worldvectorlogo.com/logos/netlify.svg",
    alt: "Netlify Logo",
  },
  {
    name: "Vercel",
    src: "https://cdn.worldvectorlogo.com/logos/vercel.svg",
    alt: "Vercel Logo",
  },
  {
    name: "Docker",
    src: "https://cdn.worldvectorlogo.com/logos/docker.svg",
    alt: "Docker Logo",
  },
];
export const aimlTechnologies = [
  {
    name: "Python",
    src: "https://cdn.worldvectorlogo.com/logos/python-5.svg",
    alt: "Python Logo",
  },
  {
    name: "TensorFlow",
    src: "https://cdn.worldvectorlogo.com/logos/tensorflow-2.svg",
    alt: "TensorFlow Logo",
  },
  {
    name: "PyTorch",
    src: "https://upload.wikimedia.org/wikipedia/commons/9/96/Pytorch_logo.png",
    alt: "PyTorch Logo",
  },
  {
    name: "MLflow",
    src: "https://cdn.brandfetch.io/idS8GMP5c8/theme/dark/logo.svg?c=1bxid64Mup7aczewSAYMX&t=1742926327412",
    alt: "MLflow Logo",
  },
  {
    name: "Pandas",
    src: "https://cdn.worldvectorlogo.com/logos/pandas.svg",
    alt: "Pandas Logo",
  },
];

export const frontendTimeLine = [
  {
    title: "Requirement Analysis",
    description:
      "We start by conducting detailed discussions to gather insights for deeply understanding your project requirements and specific technical needs to design the accurate workflow of your project.",
    icon: "/requirement.svg",
  },
  {
    title: "Frontend Architecture",
    description:
      "In this phase, we design a robust frontend architecture tailored to your frontend needs by keeping focus on scalability, performance, and maintainability.",
    icon: "/architecture.svg",
  },
  {
    title: "Prototyping",
    description:
      "Our designers create interactive prototypes and mockups, ensuring you can visualize and approve the final product before development begins.",
    icon: "/prototype.svg",
  },
  {
    title: "Development",
    description:
      "During development, our agile methodology keeps you informed at every step. Regular updates and feedback loops ensure your expectations are met.",
    icon: "/development.svg",
  },
  {
    title: "Quality Assurance",
    description:
      "We conduct a thorough testing process including functional testing, performance testing, compatibility testing and user acceptance testing. By addressing any issues early, we guarantee a polished and error-free product.",
    icon: "/quality.svg",
  },
  {
    title: "Deployment & Support",
    description:
      "Once the application passes all quality checks, we handle a seamless deployment process. Post launch, we offer ongoing maintenance and 24/7 support to keep your application updated and secure.",
    icon: "/deploy.svg",
  },
];
export const backendTimeLine = [
  {
    title: "Requirement Gathering and Analysis",
    description:
      "We begin with gathering insights into the functionality, performance, and security requirements of your backend system to understand your project needs.",
    icon: "/requirement.svg",
  },
  {
    title: "System Design and Architecture",
    description:
      "This phase results in a blueprint for a backend system that is resilient and future-ready. We create a robust backend architecture tailored to your application’s needs.",
    icon: "/architecture.svg",
  },
  {
    title: "Database Design and Development",
    description:
      "Our designers create interactive prototypes and mockups, ensuring you can visualize and approve the final product before development begins.",
    icon: "/deploy.svg",
  },
  {
    title: "API Development and Integration",
    description:
      "Our team develops and integrates APIs to facilitate seamless communication between your frontend and backend systems, as well as third-party services.",
    icon: "/design-2.svg",
  },
  {
    title: "Backend Development & Coding",
    description:
      "Our developers bring the architecture to life, coding a backend system that is robust and aligned with industry best practices.",
    icon: "/development-2.svg",
  },
  {
    title: "Quality Assurance",
    description:
      "Through extensive testing including functional, performance, compatibility, and user acceptance testing, we ensure your backend system is polished, secure, and error-free before deployment.",
    icon: "/quality.svg",
  },
  {
    title: "Deployment & Support",
    description:
      "Once your backend system is ready, we handle the deployment process to ensure a smooth launch and keep track of system performance and resolving potential issues proactively.",
    icon: "/development.svg",
  },
];
export const databaseTimeLine = [
  {
    title: "Requirement Analysis",
    description:
      "Our team works closely with you to understand your data needs and analyze the requirements to determine the best database structure and technology stack for your application. ",
    icon: "/requirement.svg",
  },
  {
    title: "Database Architecture Design",
    description:
      "We create a solid database architecture, optimized schemas, relationships, and indexes that align with your business operations.",
    icon: "/architecture.svg",
  },
  {
    title: "Data Modeling and Schema Design",
    description:
      "Our experts create precise data models that clearly define the relationships between entities, ensuring data consistency and accuracy across your application.",
    icon: "/design-2.svg",
  },
  {
    title: "Development",
    description:
      "We implement the database design, ensuring performance optimization, data integrity, and security are top priorities. Our development follows agile methodologies, with iterative progress and regular updates.",
    icon: "/development.svg",
  },
  {
    title: "Quality Assurance",
    description:
      "We conduct thorough testing, including data consistency checks, load testing, and performance assessments. Our QA team ensures that your database is free from vulnerabilities and optimized for peak performance.",

    icon: "/quality.svg",
  },
  {
    title: "Deployment & Maintenance",
    description:
      "Once all the quality checks are completed, we handle seamless database deployment and provide ongoing maintenance services to ensure your database continues to perform at its best.",
    icon: "/maintenance.svg",
  },
];
export const uiuxTimeLine = [
  {
    title: "Discovery and Requirement Analysis",
    description:
      "We begin by understanding your project’s requirements and goals, diving deep into your brand, target audience, and vision. This allows us to create a roadmap for your design project.",
    icon: "/requirement.svg",
  },
  {
    title: "Concept Development",
    description:
      "Based on the gathered insights, we begin the conceptualization phase by brainstorming design ideas and visual elements that align with your business goals.",
    icon: "/development-2.svg",
  },
  {
    title: "Prototyping and Iteration",
    description:
      "Our designers create detailed interactive prototypes to give you a tangible feel of your product before development begins. This phase allows you to see the overall flow and structure.",
    icon: "/prototype.svg",
  },
  {
    title: "User Testing and Optimization",
    description:
      "We perform multiple rounds of user testing to evaluate how real users interact with the design. This helps us fine-tune the user experience and make improvements before the final handoff.",
    icon: "/testing.svg",
  },
  {
    title: "Final Design and Handoff",
    description:
      "Once we’ve refined the design and gathered all necessary approvals, we finalize the design and prepare it for development. Our designers ensure a smooth handoff with detailed specifications and assets.",
    icon: "/design-2.svg",
  },
  {
    title: "Post-Launch Support",
    description:
      "We ensure the design is functioning as intended and troubleshoot any issues that arise post-launch.",
    icon: "/development.svg",
  },
];
export const mobileAppTimeLine = [
  {
    title: "Discovery",
    description:
      "We start by understanding your business goals, target audience, and specific needs. Our team conducts in-depth market research to prepare a dynamic workflow and ensure your app aligns with the industry trends.",
    icon: "/requirement.svg",
  },
  {
    title: "Design & Prototyping",
    description:
      "Our UX/UI experts create wireframes and prototypes that visualize the app's user interface and flow. We prioritize usability and seamless design to provide an exceptional user experience.",
    icon: "/prototype.svg",
  },
  {
    title: "Development & Integration",
    description:
      "Using the latest technologies and frameworks, we begin developing your app. We focus on scalability, security, and performance, integrating third-party APIs and services as needed to enhance functionality.",
    icon: "/development-2.svg",
  },
  {
    title: "Quality Assurance",
    description:
      "Every app goes through rigorous testing, manual and automated to ensure flawless performance across devices and platforms. We test for bugs, usability, and security, guaranteeing a smooth, error-free experience.",
    icon: "/quality.svg",
  },
  {
    title: "Launch & Deployment",
    description:
      "After thorough testing, we prepare your app for launch. We ensure it's optimized for app store submission and handle the deployment process for a smooth go-live experience.",
    icon: "/development.svg",
  },
  {
    title: "Maintenance & Support",
    description:
      "Post-launch, we offer ongoing support and updates to keep your app running smoothly and up to date with the latest features and security enhancements.",
    icon: "/maintenance.svg",
  },
];
export const cloudTimeLine = [
  {
    title: "Discovery",
    description:
      "We start by fully understanding your business challenges, and technical requirements. Our team conducts in-depth consultations to define the scope of the project and clarify what you aim to achieve through cloud adoption.",
    icon: "/requirement.svg",
  },
  {
    title: "Strategy & Planning",
    description:
      "Once we have a comprehensive understanding of your needs, our team develops a custom cloud strategy and collaborates with you to select the most appropriate cloud platforms for your solution.",
    icon: "/planning.svg",
  },
  {
    title: "Cloud Architecture Design & Development",
    description:
      "Using the latest technologies and frameworks, we begin developing your app. We focus on scalability, security, and performance, integrating third-party APIs and services as needed to enhance functionality.",
    icon: "/deploy.svg",
  },
  {
    title: "Integration & Testing",
    description:
      "We take an integration-first approach, ensuring your cloud solutions seamlessly connect with existing systems and third-party services. Our rigorous testing guarantees optimal performance and functionality across all environments.",
    icon: "/testing.svg",
  },
  {
    title: "Launch & Deployment",
    description:
      "Once your cloud solution is developed and thoroughly tested, we move on to deployment. We closely monitor the system for any issues and ensure that everything runs smoothly during the go-live phase.",
    icon: "/development.svg",
  },
  {
    title: "Maintenance & Support",
    description:
      "We provide ongoing support and maintenance to ensure your cloud solution evolves with your business needs and your system stays secure and up-to-date.",
    icon: "/maintenance.svg",
  },
];
export const aimlTimeLine = [
  {
    title: "Research",
    description:
      "We begin by identifying your business problems and evaluating your available data. Our team conducts consultations to define project goals, data sources, and success metrics for your AI/ML solution.",
    icon: "/requirement.svg",
  },
  {
    title: "Data Preparation",
    description:
      "We collect, clean, and preprocess your data to ensure it's structured, labeled, and ready for training. Feature engineering and exploratory data analysis (EDA) help us uncover key insights.",
    icon: "/wireframe-2.png",
  },
  {
    title: "Model Design",
    description:
      "We select suitable algorithms and design machine learning or deep learning models tailored to your use case. Frameworks like TensorFlow and PyTorch guide our model architecture decisions.",
    icon: "/design-2.svg",
  },
  {
    title: "Prototyping",
    description:
      "Initial models are trained and validated on your dataset. We iterate rapidly to fine-tune performance, applying techniques like hyperparameter tuning and cross-validation.",
    icon: "/prototype.svg",
  },
  {
    title: "Testing & Deployment",
    description:
      "Models undergo rigorous evaluation using test data to ensure accuracy, fairness, and stability. Once validated, we deploy the models to production and monitor them for performance and drift.",
    icon: "/testing.svg",
  },
];


export function isValidPhoneNumber(number) {
  if (!number) return false;
  const phone = parsePhoneNumberFromString(number);
  return phone ? phone.isValid() : false;
}
